<script>
import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: {
    data: {
      type: Object,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
    plugins: {
      type: Array,
      default: null,
    },
    styles: {
      type: Object,
      default: null,
    },
  },
  watch: {
    data: {
      deep: true,
      handler(newData) {
        if (!newData || !Array.isArray(newData.labels) || !Array.isArray(newData.datasets)) return
        const chart = this.$data._chart
        if (chart) {
          chart.data = newData
          chart.update({ duration: 0 })
        } else {
          this.renderChart(newData, this.options, this.plugins, this.styles)
        }
      },
    },
  },
  mounted() {
    const d = this.data
    if (d && Array.isArray(d.labels) && Array.isArray(d.datasets)) {
      this.renderChart(d, this.options, this.plugins, this.styles)
    }
  },
  beforeDestroy() {
    const chart = this.$data._chart
    if (chart) {
      try {
        chart.stop()
        chart.destroy()
      } catch (e) {
        // evita erro de transition null ao destruir
      }
      this.$data._chart = null
    }
  },
}
</script>
